import { gsap, Sine, Power0, Power1, Power2, Power3, Power4, Circ, Expo } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger.js";
import { ScrollToPlugin } from "gsap/ScrollToPlugin.js";

gsap.registerPlugin(ScrollTrigger, ScrollToPlugin);

export { gsap, ScrollTrigger, ScrollToPlugin, Sine, Power0, Power1, Power2, Power3, Power4, Circ, Expo };
